import { render, staticRenderFns } from "./TranslateArticles.vue?vue&type=template&id=ea22ccf2"
import script from "./TranslateArticles.vue?vue&type=script&lang=js"
export * from "./TranslateArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports